module.exports = __webpack_public_path__ + "img/BCfull.b201124f.png";